import { render, staticRenderFns } from "./LessonTemplates.vue?vue&type=template&id=5f574afa&scoped=true"
import script from "./LessonTemplates.vue?vue&type=script&lang=js"
export * from "./LessonTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f574afa",
  null
  
)

export default component.exports